/**
 * Componente para configurar reprodução de áudio
 * VigosCloud - Message Context System
 * 
 * Reutilizável para configurar áudio no contexto de mensagem
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faVolumeUp, 
  faInfoCircle,
  faPlay
} from '@fortawesome/free-solid-svg-icons';

import './MessageComponents.css';
import AudioSelectorUploads from '../../Audio/AudioSelectorUploads';

function AudioConfiguration({ 
  config = {
    audio_enabled: false,
    audio_file: '',
    audio_type: 'message',
    audio_accountcode: ''
  },
  onChange,
  tenant,
  disabled = false,
  title = 'Reprodução de Áudio'
}) {

  const handleChange = (field, value) => {
    if (onChange) {
      onChange({
        ...config,
        [field]: value
      });
    }
  };

  const handleAudioSelect = (fileName, fileType, accountCode) => {
    if (onChange) {
      onChange({
        ...config,
        audio_file: fileName,
        audio_type: fileType,
        audio_accountcode: accountCode
      });
    }
  };

  return (
    <div className="form-section-card" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <h3 className="title is-5 mb-4">
        <FontAwesomeIcon icon={faVolumeUp} className="mr-2" />
        {title}
      </h3>

      <div className="field">
        <label className="checkbox">
          <input
            type="checkbox"
            checked={config.audio_enabled || false}
            onChange={(e) => handleChange('audio_enabled', e.target.checked)}
            disabled={disabled}
          />
          <span className="ml-2">
            <FontAwesomeIcon icon={faVolumeUp} className="mr-2" />
            Reproduzir áudio antes do encaminhamento
          </span>
        </label>
        <p className="help">
          Se habilitado, um áudio será reproduzido antes de encaminhar para o destino
        </p>
      </div>

      {config.audio_enabled && (
        <div>
          <div className="notification is-info is-light mb-3">
            <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
            Selecione um arquivo de áudio que será reproduzido. Os arquivos devem estar no formato WAV, MP3 ou GSM.
          </div>

          <div className="field">
            <label className="label">Arquivo de Áudio *</label>
            <AudioSelectorUploads
              selectedFile={config.audio_file || ''}
              selectedType={config.audio_type || 'message'}
              accountCode={tenant}
              onSelect={handleAudioSelect}
              disabled={disabled}
            />
          </div>

          {config.audio_file && (
            <div className="notification is-success is-light mt-3">
              <div className="level">
                <div className="level-left">
                  <div className="level-item">
                    <FontAwesomeIcon icon={faPlay} className="mr-2" />
                    <strong>Arquivo selecionado:</strong>
                    <span className="ml-2">{config.audio_file}</span>
                  </div>
                </div>
                <div className="level-right">
                  <div className="level-item">
                    <span className="tag is-success">
                      Tipo: {config.audio_type?.toUpperCase()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default AudioConfiguration;

